// extracted by css-extract-rspack-plugin
module.exports =  {"nonGrid":"aINea","cards":"K5TBQ","EtimesWidget":"mDKOC","onebyoneCard":"ulrVW","content":"jR49M","titlefont":"arC9d"};